import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const BagRewardsEmptyState = () => {
  return (
    <BodyText style={styles.container} sizeMatch={['14']}>
      <FormattedMessage
        defaultMessage="No rewards are available at the moment."
        description="Bag | Rewards | Empty State"
      />
    </BodyText>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: -theme.spacing['6'],
    marginLeft: theme.spacing['8'],
  },
});
